import React from 'react';
import { AlertTriangle, Check } from 'lucide-react';
import { ToolCall } from '../../types/threads';
import { toolStyle } from '../../lib/toolStyle';

/** Inline tool-call chip in the tool's own highlighter, with running / done / error state (mobile's ToolPill). */
export const ToolPill: React.FC<{ call: ToolCall }> = ({ call }) => {
  const running = call.completed_at === null && !call.is_error;
  const errored = call.is_error;
  const { label, icon: Icon, tone } = toolStyle(call.tool_name);
  const ink = errored ? 'var(--error)' : tone.ink;
  return (
    <span
      className="pb-rise mb-1.5 mr-1.5 inline-flex items-center gap-2 rounded-full px-3 py-1.5 font-body text-[11.5px] font-semibold leading-4"
      style={{ backgroundColor: tone.fill, color: ink }}
    >
      <span className={running ? 'animate-pulse' : ''}>
        {errored ? <AlertTriangle size={13} /> : <Icon size={13} />}
      </span>
      {errored ? `${label} — hit a snag` : running ? `${label}…` : label}
      {!running && !errored && (
        <span className="flex h-3.5 w-3.5 items-center justify-center rounded-full" style={{ backgroundColor: tone.ink, color: tone.fill }}>
          <Check size={9} strokeWidth={3} />
        </span>
      )}
    </span>
  );
};
